var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.595 10.5c.5 0 .91.406.866.904A10.5 10.5 0 1 1 15.215.883c.457.2.618.754.378 1.193-.239.438-.787.595-1.248.403a8.69 8.69 0 1 0 5.298 8.924c.052-.497.453-.903.952-.903"
  })));
};
export default SvgSpinner;